// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2NF90","info":"PatientInfo_info__3j7rm"};